import { render, staticRenderFns } from "./GoodsGift.vue?vue&type=template&id=457ebee5&scoped=true&"
import script from "./GoodsGift.vue?vue&type=script&lang=ts&"
export * from "./GoodsGift.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsGift.vue?vue&type=style&index=0&id=457ebee5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ebee5",
  null
  
)

export default component.exports